import Vue from 'vue';
import { mapState } from 'vuex';

Vue.mixin({
  computed: mapState('screenSize', ['isMobile', 'isDesktop'])
});
